
//-----------------------|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||-----------------------//

export const other = {
    id: 'sample-docs-roadmap',
    type: 'group',
    children: [
        {
            id: 'auth.view_group',
            title: 'Logout',
            type: 'item',
            url: '/logout',
            icon: 'IconLogout',
            breadcrumbs: false
        },
        
    ]
};
